import { Field, Formik, useFormikContext } from "formik";
import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { isEmpty } from "lodash";
import {
  DatePicker,
  FieldDropSide,
  CsplTable as Table,
} from "../../../components";
import { required, requiredWithErrorCode, usDateFormat } from "../../../utils";
import { faPlusSquare, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDeepEffect } from "../../../abstracts";

const columns = [
  {
    label: "Hire / rehire date",
    className: "column-rehireDate",
    columnName: "reHireDate",
  },
  {
    label: "Term date",
    className: "column-termDate",
    columnName: "terminationDate",
  },
  {
    label: "Actions",
    className: "column-actions",
    columnName: "actions",
  },
];

const actionButtons = [
  {
    label: "delete",
    variant: "link",
    icon: faTrashAlt,
    color: "red",
  },
  {
    label: "add",
    variant: "link",
    icon: faPlusSquare,
    color: "blue",
  },
];

export const RehireDetails = (props) => {
  // const rehireDetails = props.rehireDetails;
  // const isEdit = props.isEdit;
  // const isSave = props.isSave;
  // const setShow= props.setShow;
  // const deleteIndex=props.deleteIndex;
  const {
    rehireDetails,
    isEdit,
    isSave,
    setShow,
    setDeleteIndex,
    setFields,
    fields1,
    values1,
    addRow,
    reassignRehireDates,
  } = props;
  const { values, setErrors, submitForm, errors } = useFormikContext();
  const onFormSubmit = (
    values,
    { setSubmitting, setErrors, setFieldError }
  ) => {
    // setErrors(error)
  };
  const requiredValidation = (value) => {
    return [undefined, null, ""].includes(value)
      ? "EM241: Required"
      : undefined;
  };
  return (
    <Form
      autoComplete="off"
      className="h-100"
      onSubmit={onFormSubmit}
      // validated={!isEmpty(rest.errors)}
    >
      <div
        className="border-box census-rehire"
        style={{
          width: "650px",
        }}
      >
        <Table>
          <Table.Thead>
            <Table.Tr>
              {columns.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {values1["rehireDetails"] &&
              values1["rehireDetails"].map((source, index) => {
                return (
                  <Table.Tr key={index}>
                    {columns.map((item, cellIndex) => {
                      return (
                        <Table.Td
                          key={cellIndex}
                          className={item.className}
                          style={{
                            marginRight:
                              item.columnName == "terminationDate" && index == 0
                                ? "3rem"
                                : null,
                          }}
                        >
                          {(item.columnName == "reHireDate" ||
                            item.columnName == "terminationDate") && (
                            <Field
                              isRequired
                              size="sm"
                              name={`${index}-${cellIndex}`}
                              value={usDateFormat(
                                values1["rehireDetails"][index][item.columnName]
                              )}
                              isDatePicker
                              validate={(val) =>
                                !(
                                  values1["rehireDetails"].length - 1 ===
                                    index &&
                                  item.columnName === "terminationDate"
                                ) &&
                                values1["rehireDetails"][index][
                                  item.columnName
                                ] == null &&
                                requiredWithErrorCode(
                                  val,
                                  item.columnName == "reHireDate"
                                    ? "EM241"
                                    : "EM242"
                                )
                              }
                              showClear={
                                values1["rehireDetails"].length - 1 === index &&
                                item.columnName === "terminationDate"
                              }
                              onClear={() => {
                                setFields(
                                  "rehireDetails",
                                  values1["rehireDetails"].map((a, b) => {
                                    if (b == index)
                                      return {
                                        ...a,
                                        [item.columnName]: null,
                                      };
                                    return a;
                                  })
                                );
                                reassignRehireDates(
                                  values1["rehireDetails"].map((a, b) => {
                                    if (b == index)
                                      return {
                                        ...a,
                                        [item.columnName]: null,
                                      };
                                    return a;
                                  })
                                );
                              }}
                              popupContent={
                                <DatePicker
                                  onDayClick={(value) => {
                                    setFields(
                                      "rehireDetails",
                                      values1["rehireDetails"].map((a, b) => {
                                        if (b == index) {
                                          if (
                                            b == 0 &&
                                            item.columnName == "reHireDate"
                                          )
                                            setFields(fields1.hireDate, value);
                                          return {
                                            ...a,
                                            [item.columnName]: value,
                                          };
                                        }
                                        return a;
                                      })
                                    );
                                    reassignRehireDates(
                                      values1["rehireDetails"].map((a, b) => {
                                        if (b == index) {
                                          return {
                                            ...a,
                                            [item.columnName]: value,
                                          };
                                        }
                                        return a;
                                      })
                                    );
                                  }}
                                  value={usDateFormat(
                                    values1["rehireDetails"][index][
                                      item.columnName
                                    ]
                                  )}
                                />
                              }
                              disabled={isEdit && !isSave}
                              component={FieldDropSide}
                            />
                          )}

                          {item.columnName == "actions" && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                width: "200px",
                              }}
                            >
                              {index != 0 && (
                                <Button
                                  variant={"link"}
                                  disabled={isEdit && !isSave}
                                >
                                  <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    color={"red"}
                                    style={{
                                      fontSize: "1.2rem",
                                    }}
                                    onClick={() => {
                                      setShow(true);
                                      setDeleteIndex(index);
                                    }}
                                  />
                                </Button>
                              )}

                              <Button
                                variant={"link"}
                                disabled={isEdit && !isSave}
                              >
                                <FontAwesomeIcon
                                  icon={faPlusSquare}
                                  color={"primary"}
                                  style={{
                                    fontSize: "1.2rem",
                                  }}
                                  onClick={() => addRow(index + 1)}
                                />
                              </Button>
                            </div>
                          )}
                          {/* {!isEmpty(item.link)
                                                                    ? item.dataMapper[source[item.columnName]]
                                                                    : usDateFormat(source[item.columnName])} */}
                        </Table.Td>
                      );
                    })}
                  </Table.Tr>
                );
              })}
          </Table.Tbody>
        </Table>
      </div>
    </Form>
  );
};
